/* eslint-disable */
import { api } from '@/services';

export default {
  async fetchCabecalhos({ dispatch, commit }, payload) {
    const { PRI_COD, FIL_COD } = payload;
    try {
      const response = await api.get(`/processo/invoice/${PRI_COD}/filial/${FIL_COD}`);
      commit('SET_CABECALHO', response.data.registros);
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar as informações do câmbio',
        { root: true },
      );
    }
  },
  async buildInvoices({ dispatch, commit }, payload) {
    if (!(Array.isArray(payload) && payload.length)) {
      commit('SET_INVOICES', []);
      return;
    }

    try {
      const { PRI_COD, FIL_COD } = payload[0];

      // Array com os códigos das invoices vinculdas ao processo X
      const codigosInvoice = [];
      payload.forEach((cabecalho) => {
        codigosInvoice.push(cabecalho.INV_COD);
      });
      // Obtem os itens de cada invoice do processo
      const value = await Promise.all(codigosInvoice.map(async (codigo) => {
        return (await api.get(`/processo/invoice/codigoInvoice/${codigo}/processo/${PRI_COD}/filial/${FIL_COD}`)).data.registros;
      }));
      // Cria objeto de invoice com o cabecalho com seus itens
      const invoice = [];
      payload.forEach(cabecalho => {
          invoice.push({
            ...cabecalho,
            itens: value.find(item => item[0].INV_COD === cabecalho.INV_COD)
          });
      });
      commit('SET_INVOICES', invoice);
    } catch (err) {
      dispatch(
        'setGlobalError',
        'Não foi possível recuperar as informações do câmbio',
        { root: true },
      );
    }
  },
  cleanInvoiceItens({ commit }) {
    commit('CLEAN_INVOICES', []);
  },
};
